import React from "react";
import { useHistory } from "react-router";
import { DiscordAuthToken } from "../../../../../common/sesh_types";
import { redirectToDiscordAuth, UserData } from "../../sesh_router";
import { WithDropdownImproved } from "./base_components/with_dropdown_improved";
import { useUserPreferencesModal } from "./hooks/use_user_preferences_modal";
import { ManualButton } from "./navbar/manual_button";
import { PremiumButton } from "./navbar/premium_button";
import { NavbarBase } from "./NavbarBase";
import { StaticNavbar } from "./StaticNavbar";

type DashboardNavbarProps = {
	user_data: UserData;
	sesh_client_id: string;
	discord_auth_token: DiscordAuthToken;
};

type NavbarProps =
	| {
			type: "static";
	  }
	| ({
			type: "dashboard";
	  } & DashboardNavbarProps);

export function Navbar(props: NavbarProps) {
	if (props.type === "static") {
		return <StaticNavbar />;
	} else if (props.type === "dashboard") {
		return <DashboardNavbar {...props} />;
	} else {
		return null;
	}
}

function DashboardNavbar(props: DashboardNavbarProps) {
	return (
		<NavbarBase>
			<div className="column is-narrow topnav-right">
				<div className="columns is-vcentered is-mobile">
					<div className="column is-narrow is-hidden-mobile">
						<ManualButton className="" />
					</div>
					<div className="column is-narrow is-hidden-mobile">
						<PremiumButton />
					</div>
					<div className="column is-narrow is-hidden-mobile">
						<a href="/blog">Blog</a>
					</div>
					<AvatarSection
						user_data={props.user_data}
						sesh_client_id={props.sesh_client_id}
						discord_auth_token={props.discord_auth_token}
					/>
				</div>
			</div>
		</NavbarBase>
	);
}

function AvatarSection(props: {
	user_data: UserData;
	sesh_client_id: string;
	discord_auth_token: DiscordAuthToken;
}) {
	const history = useHistory();

	const { setIsOpen } = useUserPreferencesModal();

	if (props.user_data) {
		return (
			<div className="ml-3">
				<div className="columns is-mobile is-vcentered">
					<div className="column is-narrow avatar-right-padding pointer-events-on">
						<figure
							className="image is-square h-8 w-8 cursor-pointer sm:h-12 sm:w-12"
							onClick={() => history.push("/dashboard/")}
						>
							<img
								className="is-rounded"
								src={props.user_data.avatar_uri}
							/>
						</figure>
					</div>
					<div className="pointer-events-on mx-2 hidden items-center gap-2 sm:flex">
						<WithDropdownImproved
							alignment="middle"
							items={[
								{
									icon: (
										<i className="fas fa-credit-card"></i>
									),
									label: "Billing",
									type: "link",
									close_on_click: true,
									props: {
										to: "/dashboard/premium",
									},
								},
								{
									icon: <i className="fas fa-cog"></i>,
									label: "Preferences",
									type: "button",
									close_on_click: true,
									props: {
										onClick: () => {
											setIsOpen(true);
										},
									},
								},
								{
									type: "divider",
								},
								{
									icon: (
										<i className="fas fa-sign-out-alt"></i>
									),
									label: "Logout",
									type: "button",
									props: {
										onClick: () => {
											redirectToDiscordAuth(
												props.sesh_client_id,
												props.discord_auth_token
													.access_token
											);
										},
									},
									is_warning: true,
								},
							]}
						>
							<div className="flex items-center gap-2">
								<span className="font-bold">
									{props.user_data.username}
								</span>
								{props.user_data.discriminator !== "0" && (
									<span>
										#{props.user_data.discriminator}
									</span>
								)}
								<i className="fas fa-chevron-down"></i>
							</div>
						</WithDropdownImproved>
					</div>
					<div className="pointer-events-on mx-2 flex items-center gap-2 sm:hidden">
						<WithDropdownImproved
							alignment="right"
							items={[
								{
									icon: <i className="fas fa-book" />,
									type: "a",
									label: "Manual",
									props: {
										href: "/manual",
									},
								},
								{
									icon: <i className="fas fa-crown" />,
									type: "link",
									label: "Premium",
									props: {
										to: {
											pathname: "/dashboard/premium",
											state: {
												prev_path: location.pathname,
											},
										},
									},
								},
								{
									icon: <i className="fas fa-newspaper" />,
									type: "a",
									label: "Blog",
									props: {
										href: "/blog",
									},
								},
								{
									type: "divider",
								},
								{
									icon: <i className="fas fa-cog"></i>,
									label: "Preferences",
									type: "button",
									props: {
										onClick: () => {
											setIsOpen(true);
										},
									},
								},
								{
									icon: (
										<i className="fas fa-sign-out-alt"></i>
									),
									label: "Logout",
									type: "button",
									props: {
										onClick: () => {
											redirectToDiscordAuth(
												props.sesh_client_id,
												props.discord_auth_token
													.access_token
											);
										},
									},
									is_warning: true,
								},
							]}
						>
							<div className="flex items-center gap-2">
								<span className="font-bold">
									{props.user_data.username}
								</span>
								{props.user_data.discriminator !== "0" && (
									<span>
										#{props.user_data.discriminator}
									</span>
								)}
								<i className="fas fa-chevron-down"></i>
							</div>
						</WithDropdownImproved>
					</div>
				</div>
			</div>
		);
	} else {
		return (
			<div>
				<div className="columns is-mobile">
					<div className="column"></div>
					<div className="column is-narrow pointer-events-on">
						<a
							href="#"
							onClick={() => {
								redirectToDiscordAuth(
									props.sesh_client_id,
									props.discord_auth_token.access_token
								);
							}}
						>
							<p className="has-text-left">Logout</p>
						</a>
					</div>
				</div>
			</div>
		);
	}
}
